import { Icon } from 'packages/eid-icons'
import { Box, useTheme } from '@mui/material'
import { Tooltip } from 'packages/eid-ui'
import { useTranslation } from 'react-i18next'

const ConnectSwitch = ({ attribute, data }) => {
    const { t } = useTranslation()
    const theme = useTheme()
    return (
        <Tooltip title={t('Common_Requestable')}>
            <Box display="flex" alignItems="center" justifyContent="center">
                <Icon
                    name="ConnectSwitch"
                    sx={{
                        color: theme?.palette?.warning?.main,
                        '&:hover': {
                            '& g': {
                                fill: `${theme?.palette?.warning?.main} !important`,
                            },
                            color: theme?.palette?.common?.white,
                        },
                    }}
                />
            </Box>
        </Tooltip>
    )
}

export default ConnectSwitch
